import { Reply } from "penpal"
import { ProgressInput } from "../../../../shared/progress"
import { IfcToLdConfig } from "./ifc-to-ld-config"
import { OpaqueSparqlResults } from "../../../../helpers/sparqlResultHelpers"
import { ViewerConfig } from "./viewer-config"
import { LayoutConfig } from "./layout-config"

export const IFC_PROGRESS_STAGES = [
  "download",
  "load-ifc",
  "load-frag",
  "convert-ifc-to-frag",
  "upload-frag",
  "stream-ifc-to-ld",
] as const

export type IfcProgressStage = typeof IFC_PROGRESS_STAGES[number]

export type ParentApi = {
  onConnected: () => void
  setProgress: (input: ProgressInput<IfcProgressStage>) => void
  setSelection: (guids: string[]) => void
}

export type FragToLdInput = {
  fragUri: string
  fragUrl: string
  targetGraphUri: string
  ifcToLdConfig: IfcToLdConfig
}

export type IFrameApi = {
  setLayoutConfig: (config: LayoutConfig) => void
  setViewerConfig: (config: ViewerConfig) => void
  setIfcUrls: (urls: string[]) => Promise<void>
  setFragmentUrls: (urls: string[]) => Promise<void>
  setSparqlResults: (results: OpaqueSparqlResults) => Promise<void>
  setSelection: (guids: string[], zoom: boolean) => Promise<void>
  convertIfcToFrag: (url: string) => Promise<Reply<Uint8Array>>
  convertFragToLd: (input: FragToLdInput) => Promise<Reply<ReadableStream<string>>>
  generateExampleIfcToLdConfig: () => Promise<IfcToLdConfig>
}
